// Module
var code = "<div *ngIf=\"showed\" class=\"alert alert-{{styleClass}}\" role=\"alert\"> <button *ngIf=\"showClose\" type=\"button\" class=\"close\" data-dismiss=\"alert\">×</button> <span [custom-label]=\"message\"></span> </div>";
// Exports
module.exports = code;